import { TimeoutForm } from './TimeoutForm';
import { ScrollArea } from '@ais-ui/ui-core';
import React from 'react';

export function TargetForm() {
  return (
    <div className="h-full">
      <ScrollArea className="pr-4">
        <div className="flex flex-col space-y-12">
          <TimeoutForm></TimeoutForm>
        </div>
      </ScrollArea>
    </div>
  );
}
